import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementBalance.Delete.IRequest;
type Response = Api.Core.StatementBalance.Delete.IResponse;
type Headers = Api.Core.StatementBalance.Delete.IHeaders;
const url = '/api/DealerManagement/StatementBalance/:id';
export default async function statementBalanceDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
